import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import ui from "../../assets/css/ui.module.scss";
import styles from "../../assets/css/credmanger.module.scss";
import { useEffect, useState } from "react";
import LoadingSpinner from "../../components/Loader";
import {
  fetchRegisteredPassKeys,
  registerPassKey,
} from "../../redux/slices/authSlice";
import BasicTable from "./Table";

const CredentialManager = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isPassKeySupported, setIsPassKeySupported] = useState(null);

  const auth = useSelector((state) => state.auth);
  const { loader } = useSelector((state) => state.app);

  const createPassKey = () => {
    console.log("createPassKey");
    dispatch(registerPassKey({ navigate }));
  };

  const checkPassKeySupport = async () => {
    const PublicKeyCredential = window.PublicKeyCredential;
    if (
      PublicKeyCredential &&
      PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable
    ) {
      Promise.all([
        PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable(),
      ])
        .then((results) => {
          if (results.every((r) => r === true)) {
            setIsPassKeySupported(true);
          }
        })
        .catch((e) => {
          console.log(e);
          setIsPassKeySupported(false);
        });
    }
  };

  const getRegisteredPasskeys = async () => {
    dispatch(fetchRegisteredPassKeys());
  };

  const {
    registerPassKey: { registrationComplete, error },
    registeredPassKeys: { passKeys, success: isFetchedRegisteredPassKeys },
  } = auth || {};

  useEffect(() => {
    checkPassKeySupport();
    getRegisteredPasskeys();
  }, []);

  const message = () => {
    if (error) {
      return <div className={styles.error}>{error}</div>;
    }
    if (registrationComplete) {
      if (registrationComplete) {
        return (
          <div className={styles.success}>Passkey created successfully</div>
        );
      }
      return (
        <div className={styles.error}>
          Some issue occurred, please try again!
        </div>
      );
    }
    return "";
  };
  console.log("registeredPassKeys", passKeys);
  return (
    <div className={styles.conatiner}>
      {isPassKeySupported ? (
        <>
          <div className={styles.heading}>Credential Manager</div>

          <div className={styles.contentBox}>
            <div className={styles.btnBox}>
              <Button
                className={`${ui.btnGolden} ${styles.btnContinue} ${styles.createBtn}`}
                onClick={createPassKey}
              >
                Create a passkey
              </Button>
            </div>
            {message()}
            {passKeys?.length ? (
              <>
                <div className={styles.registeredPassKeys}>
                  <div className={styles.registeredPassKeysTitle}>
                    Registered PassKeys:
                  </div>
                  <div>
                    <BasicTable rows={passKeys} />
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
            {isFetchedRegisteredPassKeys === false && (
              <div className={styles.error}>
                Unable to fetch registered passkeys!
              </div>
            )}
          </div>
          {loader && <LoadingSpinner />}
        </>
      ) : (
        <></>
      )}
    </div>
  );
};
export default CredentialManager;
